import { setCookie } from 'rytm-helpers'

const onBsModalHide = (e) => {
  const cookieId = e.target.dataset.modalCookieId
  if (cookieId) {
    setCookie(cookieId, "off", 0.08)
  }
}

export const initGloModal = () => {
  document.addEventListener("hide.bs.modal", onBsModalHide)
}